module.exports = __webpack_public_path__ + "create_task.1f53a4d6.mp4";